(() => {
  if (window.cbPhotoTransferLoaded) return;
  window.cbPhotoTransferLoaded = true;
  const landing = document.querySelector('[data-cb-photo-start]');
  let previewReady = false;
  window.addEventListener('customily-preview-load-finished', () => { previewReady = true; });
  const token = new URLSearchParams(location.search).get('cb_photo');
  if (!landing && !token) return;
  const dialog = document.getElementById('cb-photo-loader');
  const loaderCopy = dialog ? JSON.parse(dialog.querySelector('[data-cb-loader-copy]').textContent) : null;
  let thumbnailUrl, slowTimer, retryAction;
  const closeLoader = () => {
    clearTimeout(slowTimer);
    if (dialog?.open) dialog.close();
    document.documentElement.classList.remove('cb-photo-loading');
  };
  const showLoader = (file, stage = 'reading') => {
    if (!dialog) return;
    clearTimeout(slowTimer);
    dialog.dataset.state = 'loading';
    dialog.querySelector('h2').textContent = loaderCopy.title;
    dialog.querySelector('#cb-photo-loader-subtitle').textContent = loaderCopy.subtitle;
    dialog.querySelector('[data-cb-loader-status]').textContent = loaderCopy[stage];
    dialog.querySelector('[data-cb-loader-retry]').hidden = true;
    if (thumbnailUrl) URL.revokeObjectURL(thumbnailUrl);
    const image = dialog.querySelector('[data-cb-loader-image]');
    image.hidden = true;
    image.onload = () => { image.hidden = false; };
    image.onerror = () => { image.hidden = true; };
    if (file) {
      thumbnailUrl = URL.createObjectURL(file);
      image.src = thumbnailUrl;
    }
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('cb-photo-loading');
    dialog.querySelector('h2').focus({preventScroll:true});
    slowTimer = setTimeout(() => {
      dialog.querySelector('[data-cb-loader-status]').textContent = loaderCopy.slow;
    }, 12000);
  };
  const failLoader = () => {
    clearTimeout(slowTimer);
    if (!dialog) return;
    dialog.dataset.state = 'error';
    dialog.querySelector('h2').textContent = loaderCopy.error_title;
    dialog.querySelector('#cb-photo-loader-subtitle').textContent = loaderCopy.error_body;
    dialog.querySelector('[data-cb-loader-retry]').hidden = false;
  };
  dialog?.querySelector('[data-cb-loader-close]').addEventListener('click', closeLoader);
  dialog?.addEventListener('close', () => {
    clearTimeout(slowTimer);
    document.documentElement.classList.remove('cb-photo-loading');
  });
  dialog?.querySelector('[data-cb-loader-retry]').addEventListener('click', () => retryAction?.());
  const dbOpen = () => new Promise((resolve, reject) => {
    const request = indexedDB.open('cb-photo-transfer', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('photos');
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    request.onblocked = () => reject(new Error('storage-blocked'));
  });
  const transact = async (mode, action) => {
    const db = await dbOpen();
    return new Promise((resolve, reject) => {
      const tx = db.transaction('photos', mode);
      let result;
      const request = action(tx.objectStore('photos'));
      request.onsuccess = () => { result = request.result; };
      tx.oncomplete = () => { db.close(); resolve(result); };
      tx.onerror = tx.onabort = () => { db.close(); reject(tx.error); };
    });
  };
  if (landing) {
    const input = landing.querySelector('[data-cb-photo-file]');
    const status = landing.querySelector('[data-cb-photo-status]');
    const copy = JSON.parse(landing.querySelector('[data-cb-photo-copy]').textContent);
    retryAction = () => { closeLoader(); input.click(); };
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      closeLoader(); input.disabled = false; input.value = ''; status.textContent = '';
    });
    input.addEventListener('change', async () => {
      const file = input.files[0];
      if (!file) return;
      const extension = file.name.split('.').pop().toLowerCase();
      const types = {jpg:'image/jpeg', jpeg:'image/jpeg', png:'image/png'};
      const type = !file.type || file.type === 'application/octet-stream' ? types[extension] : file.type.toLowerCase();
      if (!Object.values(types).includes(type) || !file.size) { status.textContent = copy.invalid; input.value = ''; return; }
      input.disabled = true;
      status.textContent = copy.preparing;
      showLoader(file);
      try {
        const destination = new URL(landing.dataset.destination, location.origin);
        if (!landing.dataset.destination || destination.origin !== location.origin) throw new Error('destination');
        const id = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() :
          Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2,'0')).join('');
        const bytes = await file.arrayBuffer();
        await transact('readwrite', store => {
          store.clear();
          return store.put({bytes, name:file.name, type, lastModified:file.lastModified, created:Date.now()}, id);
        });
        destination.searchParams.set('cb_photo', id);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) destination.searchParams.set('preview_theme_id', preview);
        location.assign(destination.href);
      } catch (error) {
        status.textContent = copy.error;
        input.disabled = false;
        input.value = '';
        failLoader();
      }
    });
    return;
  }
  const host = document.querySelector('[data-cb-photo-receiver]');
  if (!host) return;
  const copy = JSON.parse(host.textContent);
  retryAction = () => location.reload();
  showLoader(null, 'preview');
  const notice = document.createElement('div');
  notice.className = 'cb-photo-transfer-notice';
  notice.setAttribute('role','status');
  notice.setAttribute('aria-live','polite');
  notice.textContent = copy.loading;
  (document.querySelector('main') || document.body).prepend(notice);
  const cleanup = async () => {
    await transact('readwrite', store => store.delete(token));
    const url = new URL(location.href); url.searchParams.delete('cb_photo');
    history.replaceState(history.state, '', url);
  };
  (async () => {
    try {
      const saved = await transact('readonly', store => store.get(token));
      if (!saved || (!saved.bytes && !saved.file) || Date.now()-saved.created > 3600000) throw new Error('expired');
      const file = saved.bytes ? new File([saved.bytes], saved.name, {type:saved.type, lastModified:saved.lastModified}) : saved.file;
      if (!file.size) throw new Error('empty');
      showLoader(file, 'preview');
      const start = Date.now();
      let imageUploaded = false;
      const timer = setInterval(() => {
        const input = document.querySelector('input[type="file"][data-element-id="1"]');
        const ready = document.querySelectorAll('.customily-swatch input[type=radio]').length >= 3 && document.readyState === 'complete';
        if (!input || input.disabled || !ready || !previewReady) {
          if (Date.now()-start > 45000) { clearInterval(timer); notice.textContent = copy.error; failLoader(); }
          return;
        }
        clearInterval(timer);
        try {
          const transfer = new DataTransfer(); transfer.items.add(file);
          input.files = transfer.files;
          window.addEventListener('customily-image-uploaded', () => { imageUploaded = true; }, {once:true});
          input.dispatchEvent(new Event('change', {bubbles:true, composed:true}));
          notice.textContent = copy.loading;
          const sent = Date.now();
          const confirmation = setInterval(() => {
            const preview = document.querySelector('.cl-canvas-container .canvas-container');
            if (imageUploaded && preview && !preview.classList.contains('op-zero') && preview.getBoundingClientRect().height > 0 && getComputedStyle(preview.closest('.cl-canvas-container')).display !== 'none') {
              clearInterval(confirmation);
              cleanup().catch(() => {});
              notice.remove();
              closeLoader();
              if (thumbnailUrl) { URL.revokeObjectURL(thumbnailUrl); thumbnailUrl = null; }
            } else if (Date.now()-sent > 60000) {
              clearInterval(confirmation); notice.textContent = copy.error; failLoader();
            }
          }, 400);
        } catch (error) { notice.textContent = copy.error; failLoader(); }
      }, 250);
    } catch (error) {
      notice.textContent = copy.error;
      failLoader();
      retryAction = () => {
        closeLoader();
        const input = document.querySelector('input[type="file"][data-element-id="1"]');
        if (input && !input.disabled) { input.value = ''; input.click(); }
      };
      cleanup().catch(() => {});
    }
  })();
})();
